import { render } from "./RntrcNovaSolicitacao.vue?vue&type=template&id=b70a2a62"
import script from "./RntrcNovaSolicitacao.vue?vue&type=script&lang=ts"
export * from "./RntrcNovaSolicitacao.vue?vue&type=script&lang=ts"
script.render = render

export default script